import { Component, OnInit , ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { ComponentInteractionService } from 'src/app/services/navbar.service';
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {

  @ViewChild('sidenav', {static: true})

  public sidenav: MatSidenav;
  constructor(private CmpIntActionService: ComponentInteractionService) {
  }


  ngOnInit() {
      this.CmpIntActionService.setSidenav(this.sidenav);
  }

  closeSideNav() {
    this.CmpIntActionService.close();
  }

  // ngAfterViewInit() {
  //   console.log(this.matSidenavContainer.nativeElement.value);
  // }

}
